var _circle, _g, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatorAddedThumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2473_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E2E5E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2473_14341)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2473_14341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E2E5E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2473_14341)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.583,
    cy: 21.5,
    r: 10.5,
    fill: "#E2E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.562 42.8765L48.583 42.906C52.035 47.7461 48.9385 55 41.9071 55C41.9071 55 36.4999 56.5 28.5178 56.5C20.5357 56.5 15.1285 55 15.1285 55C11.5302 55 8.97426 52.8387 7.83101 50.6038C6.68613 48.3657 6.53452 45.2765 8.59479 42.7173C13.0242 37.0871 20.0571 33 28.5178 33C36.8664 33 44.0082 36.7093 48.5405 42.8474L48.562 42.8765Z",
    fill: "#E2E5E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorAddedThumbnail);
export default __webpack_public_path__ + "static/media/creator-added-thumbnail.170a3fc406e8d904b0f218b8c4d47af2.svg";
export { ForwardRef as ReactComponent };